"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("../helpers/enrolment/getEnrolmentOfContent"));
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getEvaluateInteractionParam_1 = require("../helpers/getEvaluateInteractionParam");
const getCheckpointEvaluatedEvent_1 = require("../helpers/getEvent/getCheckpointEvaluatedEvent");
const evaluateInteraction_1 = require("../helpers/getInteraction/evaluateInteraction");
const getInteractionKey_1 = require("../helpers/getInteraction/getInteractionKey");
const getState_1 = require("../helpers/getState");
const getStateInteraction_1 = require("../helpers/getStateInteraction");
const entity_1 = require("../type/entity");
function updateStateInteracion(stateInteraction, reviews, evaluateResult) {
    stateInteraction.evaluation = evaluateResult;
    stateInteraction.reviews = reviews;
}
function applyEvaluateCheckpointCommand(command, user, content, states, enrolments, stateInteractions) {
    const { contentId, timeStamp, evaluateResult, creatorId: reviewerId, reviews, actorType } = command;
    const { userId, companyId } = user;
    const events = [];
    let updatedStateInteracions = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        const state = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        const currentSubmission = state.submissions[0];
        currentSubmission.submissionStatus = evaluateResult;
        currentSubmission.reviewerId = reviewerId;
        state.updatedAt = timeStamp;
        const currentContent = getContent_1.getContentByContentId(content, contentId);
        const currentEnrolment = getEnrolmentOfContent_1.default(enrolments, contentId, userId);
        updatedStateInteracions = immer_1.produce(stateInteractions, draftStateInteractions => {
            const interactionKeyForLearner = getInteractionKey_1.getInteractionKeyForLearner(contentId, entity_1.InteractionType.Evaluation, currentSubmission.submissionId, reviewerId);
            let currentStateInteraction = getStateInteraction_1.getStateInteractionByInteractionKeyForLearner(draftStateInteractions, interactionKeyForLearner);
            const doesStateInteractionAlreadyExists = !!currentStateInteraction;
            if (!currentStateInteraction) {
                const evaluateInteractionParam = getEvaluateInteractionParam_1.getEvaluateInteractionParam(command, user, reviewerId, currentSubmission.submissionId);
                // creating a new stateInteraction with current user as reviewers
                currentStateInteraction = evaluateInteraction_1.evaluateInteraction(evaluateInteractionParam);
            }
            currentStateInteraction.actorType = actorType;
            currentStateInteraction.deleted = false;
            updateStateInteracion(currentStateInteraction, reviews, evaluateResult);
            if (!doesStateInteractionAlreadyExists) {
                draftStateInteractions.push(currentStateInteraction);
            }
        });
        const contentType = getContentType_1.getContentType(currentContent);
        const checkpointEvaluatedEvent = getCheckpointEvaluatedEvent_1.getCheckpointEvaluatedEvent(command, companyId, userId, contentId, contentType, currentEnrolment.reviewerType || entity_1.ReviewerType.USER, reviewerId, evaluateResult);
        events.push(checkpointEvaluatedEvent);
    });
    return { states: updatedStates, events, stateInteractions: updatedStateInteracions, enrolments: [] };
}
exports.applyEvaluateCheckpointCommand = applyEvaluateCheckpointCommand;
//# sourceMappingURL=applyEvaluateCheckpointCommand.js.map